import _ from 'lodash/fp'

// @see https://github.com/IngeniumGolf/glfr-next/blob/S35/src/util/games.js#L29
export const calcStrokes = (holeHandicap, gameHandicap, totalHoles, ratingStyle) => {
  if(ratingStyle === "9_HOLE_RATING") {
    const strokesEach = Math.floor(gameHandicap / 9)
    const extraStrokes = gameHandicap % 9 >= holeHandicap ? 1 : 0
    return strokesEach + extraStrokes
  }

  // Assume the game is a 18 hole course...
  // How many extra shots on each hole
  // This can be 0
  const strokesEach = Math.floor(gameHandicap / 18)
  // The leftover extra shots to be distributed on the toughest holes
  const rest = gameHandicap - (18 * strokesEach)
  // If the game was on something else than 18
  // The ratio is how big or small this game was compared to 18 holes
  const ratio = 18 / totalHoles

  // Normalise the handicap to be like an 18 hole course
  const modifiedholeHandicap = holeHandicap * ratio - (ratio - 1)
  const extraStrokes = rest >= modifiedholeHandicap ? 1 : 0
  return strokesEach + extraStrokes
}

// @see https://github.com/IngeniumGolf/glfr-next/blob/S35/src/util/games.js#L46
export const calcPoints = (shots, strokes, par, sphCompare = false) => {
  if (shots === 0) {
    return 0
  }
  const extraShots = sphCompare ? strokes : 0
  return Math.max(0, par + extraShots + 2 - shots)
}

export const allShots = _.flow(_.get('holesShots'), _.reject('deletedAt'))
export const groupShots = _.groupBy('holeId')

export const getPar = _.sumBy('par')
export const getPoints = _.sumBy('points')
export const getShots = _.sumBy('shots')

export const generateHoles = (getGameDetails, handicapComparison = false, ratingStyle) => {
  const gameHandicap = _.get('game.gameHandicap', getGameDetails)
  const totalHoles = _.flow(_.get('holes'), _.size)(getGameDetails)
  return (
    _.flow(
      _.get('holes'),
      _.map((hole) => {
        const ch = calcStrokes(hole.handicap, gameHandicap, totalHoles, ratingStyle)
        const nShots = _.getOr(0, 'shots.length', hole)
        const points = calcPoints(nShots, ch, hole.par, true)
        const comparePoints = calcPoints(nShots, ch, hole.par, handicapComparison)
        return {
          ...hole,
          ch,
          points,
          nShots,
          comparePoints
        }
      })
    )(getGameDetails)
  )
}
